// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format17 } from '../../constants';

/** India */
const IN: PhoneNumberData = [91, 'IN', 10, format17];

export default IN;
